import { render, staticRenderFns } from "./safeTransferHistory.vue?vue&type=template&id=79e3e974"
import script from "./safeTransferHistory.vue?vue&type=script&lang=js"
export * from "./safeTransferHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports